import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route } from 'react-router-dom'
import { Provider } from "react-redux"
import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducers/root_reducer'
import Main from './main_container'
import { waitForRoot } from "../common/wait_for_root"
import "@fontsource/noto-sans-jp/400.css"
import "@fontsource/noto-sans-jp/700.css"
import "@fontsource/noto-sans-jp/900.css"

let store = createStore(
  rootReducer,
  applyMiddleware(
    thunk
  )
)

waitForRoot(root => {
  ReactDOM.render(
    <BrowserRouter>
      <Provider store={store}>
        <Route path='/rakuten-stay' component={Main} />
      </Provider>
    </BrowserRouter>,
    root
  )
})
